@if (isAvailable()) {
  <app-slim-button
    (clickEvent)="handleClickEvent()"
    [disabled]="!isButtonAvailable()"
    [maxWidth]="maxWidth()"
    [label]="isButtonAvailable() ? label() : inProgressLabel()"
    [theme]="theme()" />
} @else {
  <app-slim-button
    [label]="unavailableLabel()"
    [maxWidth]="maxWidth()"
    [theme]="theme()"
    [disabled]="true" />
}

<p-dialog
  [customCloseEvent]="customCloseEvent"
  [headlessTemplate]="headlessTemplateRef"
  [visible]="isDialogVisible()"
  appPrimengDialog
  appPrimengDialogCustomCloseEvent />

<ng-template #headlessTemplateRef>
  @let result = dialogResult();
  @let errorMessage = result?.errorMessage;

  <div class="p-8">
    <div class="align-center flex justify-center gap-2">
      <div class="flex justify-center text-2xl">
        @if (isNil(errorMessage)) {
          <app-icon
            [icon]="Icon.CheckCircle"
            class="text-green-600" />
        } @else {
          <app-icon
            [icon]="Icon.XCircle"
            class="text-red-600" />
        }
      </div>

      <div class="text-center font-bold uppercase">
        @if (isNil(errorMessage)) {
          Dodano do koszyka
        } @else {
          Produkt nie został dodany do koszyka
        }
      </div>
    </div>

    @if (isNotNil(errorMessage)) {
      <div class="mt-4 text-center">
        {{ errorMessage }}
      </div>
    } @else {
      @let name = result?.item?.name;
      @let amount = valueOrDefault(result?.item?.unitPrice, 0);
      @let count = quantity();
      @let total = round(count * amount);

      <div class="mt-4">
        <div class="flex flex-wrap justify-center gap-1">
          <span>Produkt</span>
          <span class="font-bold">{{ name }}</span>
          @if (count > 1) {
            <span class="font-bold">(x{{ count }})</span>
          }
          <span>-</span>
          <div class="font-bold"><app-currency [amount]="total" /></div>
          <span>został dodany do koszyka.</span>
        </div>
      </div>
    }

    <div class="mt-4 grid grid-cols-2 gap-4">
      <app-slim-button
        (clickEvent)="handleContinueClick()"
        label="Kontynuuj zakupy"
        theme="dark" />

      <app-slim-button
        (clickEvent)="handleGoToCartClick()"
        label="Przejdź do koszyka" />
    </div>
  </div>
</ng-template>
